<template>
  <div>
    <svg width="7px" height="13px" viewBox="0 0 7 13">
      <g
        id="icon-left"
        stroke="none"
        stroke-width="1"
        fill="currentColor"
        fill-rule="evenodd"
      >
        <g
          id="icon-left"
          transform="translate(-462.000000, -412.000000)"
          fill="currentColor"
        >
          <g id="icon-left" transform="translate(341.000000, 404.000000)">
            <g id="icon-left" transform="translate(10.000000, 8.000000)">
              <path
                id="icon-left"
                d="M113.351562,6.75 L117.917969,11.5078125 C118.063803,11.6536466 118.063803,11.7994784 117.917969,11.9453125 L117.097656,12.7929688 C116.951822,12.9388028 116.80599,12.9388028 116.660156,12.7929688 L111.082031,6.96875 C111.027343,6.91406223 111,6.84114629 111,6.75 C111,6.65885371 111.027343,6.58593777 111.082031,6.53125 L116.660156,0.70703125 C116.787761,0.579426445 116.933593,0.588540937 117.097656,0.734375 L117.917969,1.5546875 C118.063803,1.70052156 118.063803,1.84635344 117.917969,1.9921875 L113.351562,6.75 Z"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
    name: 'Arrow',
}
</script>
<style scoped>
svg {
  fill: currentColor;
}
</style>
